import { translate } from '../../../common/components/translation'

export const formatDistanceToMiles = (metres, locale) => {
  const miles = (metres * 0.000621371).toFixed(1)
  return translate('storefinder.store.distance.miles', locale, { count: miles })
    ?.value
}
